module.exports = __webpack_public_path__ + "static/media/icon-studio.8d22f8b1.svg";